module.exports = __webpack_public_path__ + "img/25.a132b592.png";